<div class="efa-dialog">
  <div class="efa-dialog__header">
    <span class="efa-dialog__title">{{ 'MODAL.FIRMA.TITLE' | translate }}</span>
    <button type="button" class="em-icon-btn" (click)="close()" [attr.aria-label]="'COMMON.CLOSE' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="efa-dialog__subtitle" *ngIf="data.nombreTramite">
    {{ data.nombreTramite }}
  </div>

  <div class="efa-dialog__body">
    <div class="efa-loading" *ngIf="loading">
      <div class="spinner-border spinner-border-sm" role="status"></div>
      <span>{{ 'MODAL.FIRMA.LOADING' | translate }}</span>
    </div>

    <div class="efa-error" *ngIf="!loading && error">{{ error }}</div>

    <div class="efa-empty" *ngIf="!loading && !error && autorizados.length === 0">
      {{ 'MODAL.FIRMA.EMPTY' | translate }}
    </div>

    <div class="efa-table-wrap" *ngIf="!loading && !error && autorizados.length > 0">
      <table class="efa-table">
        <thead>
          <tr>
            <th>{{ 'MODAL.FIRMA.COL_DNI' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_NAME' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_KINSHIP' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_BIRTH' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_SIGN' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_READ' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_NOTIF' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_SIGN_DATE' | translate }}</th>
            <th>{{ 'MODAL.FIRMA.COL_REJECT' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of autorizados">
            <td [attr.data-label]="'MODAL.FIRMA.COL_DNI' | translate">{{ item.documento || '-' }}</td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_NAME' | translate">{{ item.nombre || '-' }}</td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_KINSHIP' | translate">{{ item.parentesco || '-' }}</td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_BIRTH' | translate">{{ formatFecha(item.fechaNacimiento) }}</td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_SIGN' | translate">
              <span class="estado-firma" [ngClass]="estadoClass(item.estadoFirma)">{{ item.estadoFirma }}</span>
            </td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_READ' | translate">{{ item.leido }}</td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_NOTIF' | translate">{{ item.estadoNotificacion || '-' }}</td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_SIGN_DATE' | translate">{{ formatFecha(item.fechaFirmaNotificacion || item.fechaFirmaAutorizacion) }}</td>
            <td [attr.data-label]="'MODAL.FIRMA.COL_REJECT' | translate">{{ formatFecha(item.fechaRechazo) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="efa-dialog__footer">
    <button type="button" class="em-btn" (click)="close()">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>
</div>
